<template>
  <transition-group
    v-if="mnt"
    id="timeline"
    name="fadeUp"
    tag="div"
    class="timeline"
  >
    <div
      v-for="thing in $parent.timeline"
      :id="'event-' + thing.id"
      :key="thing.id"
      class="timeline-item"
    >
      <!--Icon inside the circle-->
      <div class="timeline-icon">
        <b-icon :icon="thing.icon" />
      </div>
      <div class="timeline-content">
        <h2
          class="title is-spaced"
          v-text="thing.title"
        />
        <h3
          class="subtitle"
          v-text="thing.date"
        />
        <div
          class="content"
          v-html="thing.description"
        />
        <a
          v-if="thing.url"
          :href="thing.url"
          class="button"
        >More...</a>
      </div>
    </div>
  </transition-group>
</template>

<script>
export default {
  name: 'Timeline',
  metaInfo: {
    title: 'Timeline'
  },
  data () {
    return {
      mnt: false
    }
  },
  mounted () {
    var t = this
    setTimeout(function () {
      t.mnt = true
    }, t.$parent.mntDelay)
  }
}
</script>

<style lang="scss">
// Variables
$timeline-color: #ee4d4d;
@import '../assets/timeline';
</style>
